// 获取模块主要获取数据模块
import request from '@/utils/request';

// 获取用户的信息
export const getData = () => request({url: '/look/System/getAppUserDetailed', method: 'get'});

// 获取sidebar菜单
export const getMenu = () => request({url: '/look/System/getMenuTree', method: 'get'});